interface IGetLoanPaymentArguments {
  term: number;
  rate: number;
  loan: number;
}

/**
 * Формула подсчета ежемесячного платежа
 * @param term Срок кредитования
 * @param rate Процентная ставка
 * @param loan Сумма кредита
 * Документация с расчетами https://conf.cian.tech/pages/viewpage.action?pageId=1277414060
 */
export function getLoanPayment({ term, rate, loan }: IGetLoanPaymentArguments) {
  const monthlyRate = rate / 12 / 100;
  const loanPayment = loan * monthlyRate * (1 + 1 / (Math.pow(1 + monthlyRate, term * 12) - 1));

  return Math.ceil(loanPayment);
}
